import { render, staticRenderFns } from "./NutrientModal.vue?vue&type=template&id=e832fbbc&scoped=true"
import script from "./NutrientModal.vue?vue&type=script&lang=js"
export * from "./NutrientModal.vue?vue&type=script&lang=js"
import style0 from "./NutrientModal.vue?vue&type=style&index=0&id=e832fbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832fbbc",
  null
  
)

export default component.exports